import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card, Spinner } from '@lex/ui';
import { apiClient } from '../lib/api';

export function ArticlesPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['articles', 1],
    queryFn: () => apiClient.articles.list({ page: 1 }),
  });

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-ink md:text-3xl">База знаний</h1>
      {isLoading ? (
        <Spinner />
      ) : error || !data ? (
        <Card>Не удалось загрузить статьи</Card>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {data.data.map((article) => (
            <Card key={article.id} className="transition-shadow hover:shadow-md">
              <Link to={`/articles/${article.slug}`} className="block">
                <h2 className="font-semibold text-ink">{article.title}</h2>
                {article.excerpt ? (
                  <p className="mt-1 text-sm text-muted">{article.excerpt}</p>
                ) : null}
              </Link>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
